import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  flightInformation: {
    display: 'flex',
    flexDirection: 'row',
    flexGrow: '1',
    marginRight: '10px',
    [Theme.breakpoints.down('lg')]: {
      flexDirection: 'column',
    },
    [Theme.breakpoints.down('md')]: {
      flexDirection: 'row',
    },
    [Theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      marginRight: '0',
    },
  },

  cardInfo: {
    position: 'relative',
    margin: '25px auto',
    textAlign: 'left',
    '& > p': {
      margin: '0',
    },
    [Theme.breakpoints.down('lg')]: {
      margin: '30px auto',
    },
    [Theme.breakpoints.down('md')]: {
      margin: '25px auto',
    },
    [Theme.breakpoints.down('sm')]: {
      margin: '30px auto',
    },
  },
  airlineInfo: {
    display: 'flex',
    marginLeft: '31px',
    minWidth: '230px',
    overflow: 'hidden',
    maxWidth: '340px',
    textOverflow: 'ellipsis',
    [Theme.breakpoints.down('xl')]: {
      alignItems: 'center',
      width: '50%',
    },
    [Theme.breakpoints.down('lg')]: {
      alignItems: 'flex-start',
      width: 'auto',
    },
    [Theme.breakpoints.down('md')]: {
      alignItems: 'center',
      width: '50%',
    },
    [Theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start',
      marginLeft: '20px',
      width: 'auto',
      minWidth: 'auto',
    },
  },
  itineraryInfo: {
    width: '20%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    [Theme.breakpoints.down('lg')]: {
      display: 'none',
    },
    [Theme.breakpoints.down('md')]: {
      display: 'flex',
    },
    [Theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  typeInfo: {
    width: '20%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    [Theme.breakpoints.down('lg')]: {
      display: 'none',
    },
    [Theme.breakpoints.down('md')]: {
      display: 'flex',
    },
    [Theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  flightAirline: {
    display: 'inline-block',
    marginLeft: '20px',
    textAlign: 'left',
    '& > p': {
      margin: '0',
    },
    [Theme.breakpoints.down('xl')]: {
      marginLeft: '10px',
    },
    [Theme.breakpoints.down('lg')]: {
      display: 'none',
    },
    [Theme.breakpoints.down('md')]: {
      display: 'inline-block',
    },
    [Theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  flightAirlineSmall: {
    display: 'none',
    '& > p': {
      margin: '0',
    },
    [Theme.breakpoints.down('lg')]: {
      display: 'inline-block',
      marginLeft: '11px',
    },
    [Theme.breakpoints.down('md')]: {
      display: 'none',
    },
    [Theme.breakpoints.down('sm')]: {
      display: 'inline-block',
      marginLeft: '11px',
    },
  },
  flightAirlineLogo: {
    height: '26px',
    width: '26px',
    position: 'relative',
    [Theme.breakpoints.down('lg')]: {
      top: '2px',
    },
    [Theme.breakpoints.down('md')]: {
      top: '0',
    },
    [Theme.breakpoints.down('sm')]: {
      height: '17.5px',
      width: '17.5px',
      top: '2px',
    },
  },
  standardLabel: {
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[2],
    lineHeight: '150%',
    color: Theme.palette.gray[750],
    marginBottom: '5px !important',
  },
  smallLabel: {
    fontSize: Theme.typography.size[1],
    lineHeight: '150%',
    color: Theme.palette.gray[500],
  },
  flightItinerary: {
    textTransform: 'uppercase',
  },
  flightItineraryDuration: {
    [Theme.breakpoints.down('sm')]: {
      marginLeft: '-29px !important',
      marginTop: '10px !important',
    },
  },
  flightOperatorType: {
    [Theme.breakpoints.down('sm')]: {
      marginLeft: '-29px !important',
    },
  },
  typeSmall: {
    display: 'none',
    [Theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  typeMedium: {
    [Theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  layoverDays: {
    fontSize: 'smaller',
    position: 'relative',
    top: '-5px',
  },
  expandedDepartingDate: {
    marginLeft: '10px !important',
    marginBottom: '0 !important',
    [Theme.breakpoints.down('xl')]: {
      display: 'block',
    },
    [Theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  expandedDepartingDateSmall: {
    marginLeft: '10px !important',
    '& > p': {
      margin: '0',
    },
    [Theme.breakpoints.down('xl')]: {
      display: 'none',
    },
    [Theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
}));

export default useStyles;
